import { WarningOutlineIcon } from '@toasttab/buffet-pui-icons'
import React, { CSSProperties } from 'react'
import {
  Id,
  Slide,
  toast,
  ToastContainer,
  ToastOptions,
  CloseButtonProps
} from 'react-toastify'

export const SitesToastContainer = ({
  containerId = 'mainToastContainer',
  style,
  className = 'navToastContainer'
}: {
  containerId?: Id
  style?: CSSProperties
  className?: string
}) => {
  return (
    <ToastContainer
      position='bottom-center'
      containerId={containerId}
      className={className}
      enableMultiContainer
      autoClose={3000}
      transition={Slide}
      hideProgressBar
      newestOnTop={false}
      closeButton={TooltipCloseIcon}
      style={style}
      closeOnClick
      rtl={false}
      draggable
      pauseOnHover
      theme='dark'
      limit={2}
    />
  )
}

export const alertSuccess = (message: string, options?: ToastOptions) => {
  toast.success(message, {
    ...options,
    role: options?.role ?? 'alert',
    containerId: options?.containerId ?? 'mainToastContainer'
  })
}

export const alertError = (message: string, options?: ToastOptions) => {
  toast.error(message, {
    ...options,
    role: options?.role ?? 'alert ',
    containerId: options?.containerId ?? 'mainToastContainer'
  })
}

export const alertWarning = (message: string, options?: ToastOptions) => {
  toast.warning(message, {
    ...options,
    role: options?.role ?? 'alert',
    containerId: options?.containerId ?? 'mainToastContainer',
    icon: <WarningOutlineIcon accessibility='decorative' />
  })
}

const TooltipCloseIcon = ({ closeToast }: CloseButtonProps) => {
  return (
    <button className='toastCloseButton' onClick={closeToast}>
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        role='button'
      >
        <path
          d='M4.10059 4.1001L11.9006 11.9001M11.9006 4.1001L4.10059 11.9001'
          stroke='white'
          strokeWidth='0.9'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </button>
  )
}
